"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./add-buff"), exports);
var add_buff_1 = require("./add-buff");
exports.addBuffProcessor = add_buff_1.default;
tslib_1.__exportStar(require("./attack"), exports);
var attack_1 = require("./attack");
exports.attackProcessor = attack_1.default;
tslib_1.__exportStar(require("./battle"), exports);
var battle_1 = require("./battle");
exports.battleProcessor = battle_1.default;
tslib_1.__exportStar(require("./event"), exports);
var event_1 = require("./event");
exports.eventProcessor = event_1.default;
tslib_1.__exportStar(require("./remove-buff"), exports);
var remove_buff_1 = require("./remove-buff");
exports.removeBuffProcessor = remove_buff_1.default;
tslib_1.__exportStar(require("./turn"), exports);
var turn_1 = require("./turn");
exports.turnProcessor = turn_1.default;
// export {default as updateHpProcessor} from './update-hp';
// export * from  './update-hp';
var update_mana_1 = require("./update-mana");
exports.updateManaProcessor = update_mana_1.default;
tslib_1.__exportStar(require("./update-mana"), exports);
var update_mana_progress_1 = require("./update-mana-progress");
exports.updateManaProcessProcessor = update_mana_progress_1.default;
tslib_1.__exportStar(require("./update-mana-progress"), exports);
var update_runway_1 = require("./update-runway");
exports.updateRunwayProcessor = update_runway_1.default;
tslib_1.__exportStar(require("./update-runway"), exports);
var use_skill_1 = require("./use-skill");
exports.useSkillProcessor = use_skill_1.default;
tslib_1.__exportStar(require("./use-skill"), exports);
var fake_turn_1 = require("./fake-turn");
exports.FakeTurnProcessor = fake_turn_1.default;
tslib_1.__exportStar(require("./fake-turn"), exports);
var wait_input_1 = require("./wait-input");
exports.WaitInputProcessor = wait_input_1.default;
tslib_1.__exportStar(require("./wait-input"), exports);
